// extracted by mini-css-extract-plugin
export default {"box":"ChaptersPopup_box__w7OQ9","item":"ChaptersPopup_item__836+4","active":"ChaptersPopup_active__wxYf-","popWrapper":"ChaptersPopup_popWrapper__zjIN1"};